import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import { apiCall } from '../../helpers/MainHelper';
import { toast } from 'react-toastify';
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2';
import './VehicleAvatarManagement.css';

class VehicleAvatarManagement extends Component {
  state = {
    avatars: [],
    loading: true,
    showModal: false,
    modalType: '', // 'create' or 'update'
    selectedAvatar: null,
    formData: {
      name: '',
      image: null,
      glb_file: null,
    },
    imagePreview: null,
    processingAction: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.fetchAvatars();
  }

  fetchAvatars = async () => {
    try {
      this.setState({ loading: true });
      const response = await apiCall('admin/vehicle-avatars/list', 'get');

      if (response.status === 'success') {
        this.setState({ avatars: response.data || [], loading: false });
      } else {
        toast.error('Avatar listesi yüklenemedi');
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching avatars:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
      this.setState({ loading: false });
    }
  };

  handleOpenCreateModal = () => {
    this.setState({
      showModal: true,
      modalType: 'create',
      selectedAvatar: null,
      formData: {
        name: '',
        image: null,
        glb_file: null,
      },
      imagePreview: null,
    });
  };

  handleOpenUpdateModal = (avatar) => {
    this.setState({
      showModal: true,
      modalType: 'update',
      selectedAvatar: avatar,
      formData: {
        name: avatar.name || '',
        image: null,
        glb_file: null,
      },
      imagePreview: avatar.image_url || null,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      modalType: '',
      selectedAvatar: null,
      formData: {
        name: '',
        image: null,
        glb_file: null,
      },
      imagePreview: null,
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [name]: value,
      },
    });
  };

  handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error('Lütfen geçerli bir resim dosyası seçin');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({
          formData: {
            ...this.state.formData,
            image: file,
          },
          imagePreview: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  handleGlbFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'model/gltf-binary' && !file.name.endsWith('.glb')) {
        toast.error('Lütfen geçerli bir .glb dosyası seçin');
        return;
      }
      this.setState({
        formData: {
          ...this.state.formData,
          glb_file: file,
        },
      });
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { modalType, formData } = this.state;

    if (!formData.name || formData.name.trim() === '') {
      toast.error('Lütfen avatar adı girin');
      return;
    }

    if (modalType === 'create' && (!formData.image || !formData.glb_file)) {
      toast.error('Lütfen resim ve .glb dosyası yükleyin');
      return;
    }

    this.setState({ processingAction: true });

    try {
      const submitFormData = new FormData();
      submitFormData.append('name', formData.name);
      
      if (formData.image) {
        submitFormData.append('image', formData.image);
      }
      if (formData.glb_file) {
        submitFormData.append('glb_file', formData.glb_file);
      }

      const endpoint = modalType === 'create'
        ? 'admin/vehicle-avatars/create'
        : `admin/vehicle-avatars/update/${this.state.selectedAvatar.id}`;

      const response = await apiCall(endpoint, 'post', submitFormData);

      if (response.status === 'success') {
        toast.success(response.message);
        this.handleCloseModal();
        this.fetchAvatars();
      } else {
        toast.error(response.message || 'İşlem başarısız');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
    } finally {
      this.setState({ processingAction: false });
    }
  };

  handleDelete = async (avatar) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et'
    });

    if (result.isConfirmed) {
      try {
        const response = await apiCall(`admin/vehicle-avatars/delete/${avatar.id}`, 'delete');

        if (response.status === 'success') {
          toast.success('Avatar başarıyla silindi');
          this.fetchAvatars();
        } else {
          toast.error(response.message || 'Silme işlemi başarısız');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('Bir hata oluştu: ' + (error.response?.data?.message || error.message));
      }
    }
  };

  render() {
    const { avatars, loading, showModal, modalType, formData, imagePreview, processingAction } = this.state;

    return (
      <div
        className="admin-vehicle-avatar-management"
        onClick={() => {
          document.body.classList.remove('offcanvas-active');
        }}
      >
        <div className="page-loader-wrapper" style={{ display: loading ? 'block' : 'none' }}>
          <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="m-t-30">
              <img src={require('../../assets/images/logo-white.png')} width="150" alt="ServiceZone" />
            </div>
            <p>Yükleniyor</p>
            <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
          </div>
        </div>

        <div className="container-fluid">
          <PageHeader
            HeaderText="Araç Avatar Yönetimi"
            Breadcrumb={[
              { name: 'Admin', navigate: '' },
              { name: 'Araç Avatar', navigate: '' },
            ]}
          />

          <div className="row clearfix mb-4">
            <div className="col-12">
              <button
                className="btn btn-primary"
                onClick={this.handleOpenCreateModal}
              >
                <i className="fa fa-plus"></i> Yeni Avatar Ekle
              </button>
            </div>
          </div>

          <div className="row clearfix">
            {avatars.length > 0 ? (
              avatars.map((avatar) => (
                <div key={avatar.id} className="col-lg-4 col-md-6 mb-4">
                  <div className="avatar-card">
                    <div className="avatar-image-container">
                      {avatar.image_url ? (
                        <img src={avatar.image_url} alt={avatar.name} className="avatar-image" />
                      ) : (
                        <div className="avatar-placeholder">
                          <i className="fa fa-image"></i>
                        </div>
                      )}
                    </div>
                    <div className="avatar-info">
                      <h4>{avatar.name}</h4>
                      {avatar.glb_url && (
                        <p className="text-muted">
                          <i className="fa fa-cube"></i> 3D Model Mevcut
                        </p>
                      )}
                      <p className="text-muted small">
                        Oluşturulma: {new Date(avatar.created_at).toLocaleDateString('tr-TR')}
                      </p>
                    </div>
                    <div className="avatar-actions">
                      <button
                        className="btn btn-sm btn-info"
                        onClick={() => this.handleOpenUpdateModal(avatar)}
                      >
                        <i className="fa fa-edit"></i> Düzenle
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => this.handleDelete(avatar)}
                      >
                        <i className="fa fa-trash"></i> Sil
                      </button>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="empty-state text-center">
                  <i className="fa fa-cube" style={{ fontSize: '64px', color: '#ccc' }}></i>
                  <p>Henüz avatar eklenmemiş</p>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleOpenCreateModal}
                  >
                    İlk Avatarı Ekle
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modal for Create/Update Avatar */}
        {showModal && (
          <div className="modal-overlay" onClick={this.handleCloseModal}>
            <div className="avatar-modal" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={this.handleCloseModal}>
                ×
              </button>

              <h2 className="modal-title">
                {modalType === 'create' ? 'Yeni Avatar Ekle' : 'Avatarı Güncelle'}
              </h2>

              <form onSubmit={this.handleSubmit} className="avatar-form">
                <div className="form-group">
                  <label>Avatar Adı *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={this.handleInputChange}
                    placeholder="örn: BMW 3 Series"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Resim *</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleImageChange}
                    required={modalType === 'create'}
                  />
                  {imagePreview && (
                    <div className="image-preview mt-2">
                      <img src={imagePreview} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label>3D Model (.glb) *</label>
                  <input
                    type="file"
                    accept=".glb,model/gltf-binary"
                    onChange={this.handleGlbFileChange}
                    required={modalType === 'create'}
                  />
                  {formData.glb_file && (
                    <p className="text-success mt-2">
                      <i className="fa fa-check"></i> {formData.glb_file.name}
                    </p>
                  )}
                </div>

                <div className="modal-actions">
                  <button type="button" className="btn btn-cancel" onClick={this.handleCloseModal}>
                    İptal
                  </button>
                  <button type="submit" className="btn btn-submit" disabled={processingAction}>
                    {processingAction ? (
                      <>
                        <ReactLoading type="spin" color="#fff" width={20} height={20} />
                        <span>İşleniyor...</span>
                      </>
                    ) : (
                      <>
                        <i className="fa fa-save"></i>
                        {modalType === 'create' ? 'Avatar Oluştur' : 'Avatarı Güncelle'}
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(VehicleAvatarManagement);

